import React from 'react';
import GameWorld from './components/GameWorld';
export function App() {
  return <div className="w-full h-screen bg-gray-900 overflow-hidden" data-id="element-0">
      <GameWorld data-id="element-1" />
    </div>;
}